var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFi11785255(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1230_354)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.2083 38.0007C8.16842 38.0007 0 29.8322 0 19.7923C0 9.7524 8.16842 1.58398 18.2083 1.58398C28.2483 1.58398 36.4167 9.7524 36.4167 19.7923C36.4167 29.8322 28.2483 38.0007 18.2083 38.0007ZM18.2083 3.16732C9.04083 3.16732 1.58333 10.6248 1.58333 19.7923C1.58333 28.9598 9.04083 36.4173 18.2083 36.4173C27.3758 36.4173 34.8333 28.9598 34.8333 19.7923C34.8333 10.6248 27.3758 3.16732 18.2083 3.16732Z",
    fill: "#161717"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.334 27.7091C25.1313 27.7091 24.9286 27.6315 24.7735 27.4779L10.5236 13.2279C10.2148 12.9192 10.2148 12.4173 10.5236 12.1085C10.8323 11.7998 11.3342 11.7998 11.643 12.1085L25.8931 26.3585C26.2018 26.6672 26.2018 27.1691 25.8931 27.4779C25.7395 27.6315 25.5368 27.7091 25.334 27.7091Z",
    fill: "#161717"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.0841 27.7091C10.8814 27.7091 10.6787 27.6315 10.5236 27.4779C10.2148 27.1691 10.2148 26.6672 10.5236 26.3585L24.7735 12.1085C25.0822 11.7998 25.5843 11.7998 25.8931 12.1085C26.2018 12.4173 26.2018 12.9192 25.8931 13.2279L11.643 27.4779C11.4894 27.6315 11.2867 27.7091 11.0841 27.7091Z",
    fill: "#161717"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1230_354"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 38,
    height: 38,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFi11785255);
export default __webpack_public_path__ + "static/media/fi_11785255.8652dfb22881caca87a3ce81cbce0f78.svg";
export { ForwardRef as ReactComponent };